<template>
    <div class="detail_swiper">
        <swiper ref="swiper" :options="options">
            <template v-for="(item, index) in data">
                <swiper-slide :key="index">
                    <div class="cover" :style="`background-image: url(${item});`"></div>
                </swiper-slide>
            </template>
        </swiper>
        <!-- <div class="swiper-button-prev" slot="button-prev"></div> -->
        <div class="swiper-button-next" slot="button-next"></div>
        <div class="swiper-pagination"></div>
    </div>
</template>

<script>
import { swiper, swiperSlide, directive, navigation } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
    name: "detailSwiper",
    props: [ 'data' ],
    data() {
        return {
            options: {
                slidesPerView: 'auto',
                resistanceRatio: 0,
                navigation: {
                    prevEl: '.detail_swiper .swiper-button-prev',
                    nextEl: '.detail_swiper .swiper-button-next',
                },
                pagination: {
                    el: '.detail_swiper .swiper-pagination',
                    clickable: true,
                },
                observer: true,
                observeParents: true,
                spaceBetween: '3%',
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.swiper.swiper
        },
    },
    components: {
        swiper,
        swiperSlide,
        
    },
    mounted() {},
    watch: {},
    methods: {},
    destroyed() {},
};
</script>

<style scoped lang="scss">
.detail_swiper{
    position: relative;
    .swiper-slide{
        width: 7.66rem;
        height: 5.14rem;
        .cover{
            width: 100%;
            height: 100%;
            background: no-repeat center/cover;
            border-radius: .04rem;
        }
    }
    .swiper-button-prev,
    .swiper-button-next{
        width: .54rem;
        height: .54rem;
        background: no-repeat 0/100%;
        margin-top: -.27rem;
        &::after{
            display: none;
        }
        &.swiper-button-disabled{
            opacity: 0;
        }
    }
    .swiper-button-prev{
        left: -.3rem;
        background-image: url('~@/assets/images/icon_arrow_prev.svg');
    }
    .swiper-button-next{
        right: .2rem;
        // background-image: url('~@/assets/images/icon_arrow_next.svg');
        background-image: url('~@/assets/images/icon_detail_swiper_next.png');
    }
    .swiper-pagination{
        display: none;
    }
    @media only screen and (max-width: 1200px) {
        .swiper-slide{
            width: 100%;
            height: 10rem;
            padding: 0 .12rem;
            .cover{
                border-radius: .2rem;
            }
        }
        .swiper-button-prev,
        .swiper-button-next{
            display: none;
        }
        .swiper-pagination{
            position: absolute;
            bottom: .5rem;
            width: 100%;
            display: flex;
            justify-content: center;
            /deep/ {
                .swiper-pagination-bullet{
                    width: .3rem;
                    height: .3rem;
                    border-radius: 50%;
                    background: #fff;
                    margin: 0 .2rem;
                    opacity: .6;
                    &.swiper-pagination-bullet-active{
                        opacity: 1;
                    }
                }
            }
        }
    }
}
</style>